var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29370_156)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M54.6511 5.46512H5.46509V54.6512H54.6511V5.46512Z",
    fill: "#00739F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.16279 7.55814H0V0H7.55814V1.16279H1.16279V7.55814Z",
    fill: "#00739F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 7.55814H58.8372V1.16279H52.4419V0H60V7.55814Z",
    fill: "#00739F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 60H52.4419V58.8372H58.8372V52.4419H60V60Z",
    fill: "#00739F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.55814 60H0V52.4419H1.16279V58.8372H7.55814V60Z",
    fill: "#00739F"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_29370_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6504 44H37.585C37.1464 44 36.7908 43.6444 36.7908 43.2058C36.7908 42.7671 37.1464 42.4115 37.585 42.4115H39.6504C41.1728 42.4115 42.4115 41.1729 42.4115 39.6504V20.3496C42.4115 18.8272 41.1729 17.5885 39.6504 17.5885H27.7232C27.2845 17.5885 26.929 17.2329 26.929 16.7942C26.929 16.3556 27.2845 16 27.7232 16H39.6504C42.0488 16 44 17.9512 44 20.3496V39.6504C44 42.0488 42.0488 44 39.6504 44ZM31.8426 44H20.3496C17.9512 44 16 42.0488 16 39.6504V20.3496C16 17.9512 17.9512 16 20.3496 16H22.137C22.5757 16 22.9313 16.3556 22.9313 16.7942C22.9313 17.2329 22.5757 17.5885 22.137 17.5885H20.3496C18.8272 17.5885 17.5885 18.8271 17.5885 20.3496V39.6504C17.5885 41.1728 18.8271 42.4115 20.3496 42.4115H31.8426C32.2812 42.4115 32.6368 42.7671 32.6368 43.2058C32.6368 43.6444 32.2812 44 31.8426 44Z",
    fill: "#63B6D4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30 33.75C27.93 33.75 26.25 32.07 26.25 30C26.25 27.93 27.93 26.25 30 26.25C32.07 26.25 33.75 27.93 33.75 30C33.75 32.07 32.07 33.75 30 33.75Z",
    fill: "#63B6D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0125 26.715C33.6 26.715 33.2625 26.3775 33.2625 25.965C33.2625 25.5525 33.6 25.215 34.0125 25.215C34.425 25.215 34.7625 25.5525 34.7625 25.965C34.7625 26.3775 34.425 26.715 34.0125 26.715Z",
    fill: "#63B6D4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.75 22.5H26.25C24.18 22.5 22.5 24.18 22.5 26.25V33.75C22.5 35.82 24.18 37.5 26.25 37.5H33.75C35.82 37.5 37.5 35.82 37.5 33.75V26.25C37.5 24.18 35.82 22.5 33.75 22.5ZM26.25 30C26.25 32.07 27.93 33.75 30 33.75C32.07 33.75 33.75 32.07 33.75 30C33.75 27.93 32.07 26.25 30 26.25C27.93 26.25 26.25 27.93 26.25 30ZM33.2625 25.965C33.2625 26.3775 33.6 26.715 34.0125 26.715C34.425 26.715 34.7625 26.3775 34.7625 25.965C34.7625 25.5525 34.425 25.215 34.0125 25.215C33.6 25.215 33.2625 25.5525 33.2625 25.965Z",
    fill: "#E9F7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 32.25C31.2426 32.25 32.25 31.2426 32.25 30C32.25 28.7574 31.2426 27.75 30 27.75C28.7574 27.75 27.75 28.7574 27.75 30C27.75 31.2426 28.7574 32.25 30 32.25Z",
    fill: "#E9F7FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29370_156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_29370_156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.5dd70b40bf27b0c7f38495ee37f536dd.svg";
export { ForwardRef as ReactComponent };